// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"ab58edfb","450":"2df16de6"}[chunkId] + ".chunk.js";
};